import "./KTrucksMapSidebar.scss";
import KTrucksMapSidebarRow from "./KTrucksMapSidebarRow";
import Sidebar from "../mixins/sidebar";
import { KDataTable } from "kinnect-general";
import {
	VBtn,
	VCard,
	VCardText,
	VCol,
	VDivider,
	VIcon,
	VSpacer,
	VToolbar,
	VToolbarTitle
} from "vuetify/lib";
import {
	getObjectValueByPath,
	sortItems
} from "vuetify/lib/util/helpers";

export default {
	name: "KTrucksMapSidebar",

	inject: [ "storeModuleName" ],

	mixins: [ Sidebar ],

	props: {
		trucks: {
			default: () => [],
			type: Array
		}
	},

	data: () => ( {
		headers: [
			{
				text: "Status"
			},
			{
				text: "Driver",
				value: "activeTrip.driverNames"
			},
			{
				text: "Truck",
				value: "name"
			},
			{
				text: "Last Report",
				value: "timestamp"
			}
		]
	} ),

	computed: {
		show: {
			get() {
				return this.$store.state[this.storeModuleName].sidebar;
			},
			set( value ) {
				this.$store.dispatch( `${this.storeModuleName}/setSidebar`, value );
			}
		},

		alerts: {
			get() {
				return this.$store.state[this.storeModuleName].alerts;
			},
			set( value ) {
				this.$store.dispatch( `${this.storeModuleName}/setAlerts`, value );
			}
		}
	},

	methods: {
		sortEmptyItemsLast( items, sortBy, sortDesc, ...params ) {
			return sortItems( items, sortBy, sortDesc, ...params ).sort( ( a, b ) => {
				for ( let i = 0; i < sortBy.length; i++ ) {
					const sortKey = sortBy[i];
					const sortA = getObjectValueByPath( a, sortKey );
					const sortB = getObjectValueByPath( b, sortKey );

					if ( !sortA ) {
						return 1;
					}

					if ( !sortB ) {
						return -1;
					}

					return 0;
				}
			} );
		}
	},

	render() {
		if ( !this.show ) {
			return;
		}

		return <VCol class={[
			this.sidebarClasses,
			"pr-0"
		]}>
			<VToolbar flat class="transparent">
				<VToolbarTitle>Trucks</VToolbarTitle>
				<VSpacer></VSpacer>
				<VBtn icon onClick={() => this.show = false}>
					<VIcon>close</VIcon>
				</VBtn>
			</VToolbar>

			<VDivider></VDivider>

			<KDataTable
				customSort={this.sortEmptyItemsLast}
				dense
				headers={this.headers}
				hideDefaultFooter
				items={this.trucks}
				itemsPerPage={-1}
				loading={this.loading}
				mustSort
				noDataText="There are no trucks to display"
				sortBy="activeTrip.driverNames"
				scopedSlots={{
					item: props =>
						<KTrucksMapSidebarRow
							expanded={props.expanded}
							on={{ "update:expanded": val => props.expanded = val }}
							truck={props.item}
						></KTrucksMapSidebarRow>,

					expand: () => [
						<VCard flat>
							<VCardText>
								<VBtn color="error" onClick={() => this.alerts = !this.alerts}>
									<VIcon left>notifications</VIcon>Alerts
								</VBtn>
							</VCardText>
						</VCard>
					]
				}}
			></KDataTable>
		</VCol>;
	}
};
